import React, { useState } from 'react';
import { useCart } from '../context/CartContext';
import { useNavigate } from 'react-router-dom';
import axios from 'axios';
import CheckoutSkeleton from './skeletons/CheckoutSkeleton';
import { useEffect } from 'react'; // if not already
import { useAuth } from '../context/AuthProvider';

const CheckoutPage = () => {
  const { cart, clearCart } = useCart();
  const navigate = useNavigate();
  const [loading, setLoading] = useState(true);
  const { user, setUser } = useAuth();


  useEffect(() => {
    if (user) {
      setForm((prevForm) => ({
        ...prevForm,
        name: user.name || '',
        phone: user.phone ? user.phone.replace('+964', '') : '',
        email: user.email || '',
      }));
    }
  }, [user]);
  useEffect(() => {
    const timeout = setTimeout(() => setLoading(false), 600);




    return () => clearTimeout(timeout);
  }, []);


  const [form, setForm] = useState({
    name: '',
    phone: '',
    verificationCode: '',
    phoneVerified: false,
    email: '',
    address: '',
    city: '',
    note: '',
    paymentMethod: 'cod',
    guarantee: true,
  });

  const [codeSent, setCodeSent] = useState(false);
  const [sendingCode, setSendingCode] = useState(false);
  const [verifying, setVerifying] = useState(false);
  const [verificationMessage, setVerificationMessage] = useState('');
const [promoCode, setPromoCode] = useState(() => {
  return localStorage.getItem('promoCode') || '';
});
const [discount, setDiscount] = useState(() => {
  return parseFloat(localStorage.getItem('promoDiscount') || '0');
});

  const isValidIraqiPhone = (number) => {
    const regex = /^7[4-9][0-9]{8}$/;
    return regex.test(number);
  };


  const baseTotal = cart.reduce((sum, item) => sum + item.price * (item.quantity || 1), 0);
  const guaranteeFee = form.guarantee ? 5 : 0;
  const total = Number((baseTotal + guaranteeFee - discount).toFixed(2));


  const handleChange = (e) => {
    setForm({ ...form, [e.target.name]: e.target.value });
  };


  const [savedAddresses, setSavedAddresses] = useState([]);
  useEffect(() => {
    if (user) {
      axios.get("/api/users/addresses", {
        headers: { Authorization: "Bearer " + localStorage.getItem("token") }
      }).then(res => {
        setSavedAddresses(res.data);
      });
    }
  }, [user]);

  useEffect(() => {
    if (user && savedAddresses.length > 0) {
      const defaultAddr = savedAddresses.find(a => a.isDefault) || savedAddresses[0];
      setForm(prevForm => ({
        ...prevForm,
        address: defaultAddr.addressLine,
        city: defaultAddr.city,
        phone: defaultAddr.phone ? defaultAddr.phone.replace('+964', '') : prevForm.phone,
        selectedAddressIndex: savedAddresses.findIndex(a => a === defaultAddr)
      }));
    }
  }, [savedAddresses, user]);

  // Normalize and format phone input
  const handlePhoneChange = (e) => {
    let number = e.target.value.replace(/\D/g, '');
    if (number.startsWith('0')) number = number.slice(1);
    setForm({ ...form, phone: number });
  };

  const sendVerificationCode = async () => {
    if (form.phone.length < 10) {
      setVerificationMessage('Please enter a valid phone number.');
      return;
    }
    setSendingCode(true);
    try {
      await axios.post('/api/send-code', { phone: `+964${form.phone}` });
      setCodeSent(true);
      setVerificationMessage('Verification code sent via WhatsApp.');
    } catch (error) {
      setVerificationMessage('Failed to send verification code. Try again.');
    } finally {
      setSendingCode(false);
    }
  };

  const verifyCode = async () => {
    setVerifying(true);
    try {
      await axios.post('/api/verify-code', {
        phone: `+964${form.phone}`,
        code: form.verificationCode
      });
      setForm(prev => ({ ...prev, phoneVerified: true }));
      setVerificationMessage('Phone number successfully verified!');
    } catch (error) {
      setVerificationMessage('Invalid verification code. Please try again.');
    } finally {
      setVerifying(false);
    }
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    if (!form.name || !form.phone || !form.address || !form.city) {
      alert('Please fill in all required fields.');
      return;

    }

    const orderDetails = {
      customer: {
        name: form.name,
        phone: `+964${form.phone}`,
        email: form.email,
        address: form.address,
        city: form.city
      },
      items: cart.map(item => ({
        productId: item._id,        // backend uses this (must be MongoDB ObjectId)
        customId: item.productId,   // frontend uses this (L-15, 88, etc.)
        name: item.name,
        size: item.size,
        quantity: item.quantity || 1,
        price: item.price,
        photo: item.photos?.[0] || '',
        weight: item.weight ?? 0
      }))
      ,
      totalAmount: parseFloat(total),
      note: form.note,
      paymentMethod: form.paymentMethod,
      guarantee: form.guarantee, // ✅ NEW
      promoCode: discount > 0 ? promoCode.trim().toUpperCase() : null
    };


    try {
      const res = await axios.post('/api/direct-orders/create', orderDetails);
      // If phone is verified, register and login the user automatically
      if (!user) {
        try {
          // 1. Register user regardless of phoneVerified
          await axios.post('/api/users/register', {
            name: form.name,
            phone: `+964${form.phone}`,
            password: form.phone,
            email: form.email || ""
          });

        } catch (err) {
          // Allow "phone already registered" to pass
          if (!err.response?.data?.error?.includes("already")) {
            throw err;
          }
        }

        // 2. Login after registration
        const loginRes = await axios.post('/api/users/login', {
          phone: `+964${form.phone}`,
          password: form.phone
        });
        localStorage.setItem('token', loginRes.data.token);

        // ✅ Fetch the user and update context without reload
        const userInfo = await axios.get("/api/users/me", {
          headers: { Authorization: loginRes.data.token }
        });
        setUser(userInfo.data); // ✅ Now user is logged in


      }

      localStorage.setItem('lastOrderInfo', JSON.stringify({
        orderId: res.data.orderId,
        method: form.email && form.email.includes('@') ? 'email' : 'phone'
      }));

      // (Inside handleSubmit, after login success, before clearCart)
      const token = localStorage.getItem("token");

      try {
        const addressRes = await axios.get("/api/users/addresses", {
          headers: { Authorization: `Bearer ${token}` }
        });

        const alreadySaved = addressRes.data.some(addr =>
          addr.addressLine === form.address &&
          addr.city === form.city &&
          addr.phone === `+964${form.phone}`
        );

        if (!alreadySaved) {
          await axios.post("/api/users/addresses", {
            label: "Home",
            addressLine: form.address,
            city: form.city,
            phone: `+964${form.phone}`,
            isDefault: addressRes.data.length === 0
          }, {
            headers: { Authorization: `Bearer ${token}` }
          });
        }
      } catch (err) {
        console.error("❌ Failed to save address:", err.response?.data || err.message);
      }


      clearCart();
      localStorage.removeItem('promoDiscount'); // ✅ Clear applied promo
      localStorage.removeItem('promoCode');
      navigate(`/thank-you?orderId=${res.data.orderId}`);

    } catch (error) {
      console.error('Order submission failed:', error);
      alert('Failed to place order. Please try again.');
    }
  };

  if (loading) return <CheckoutSkeleton />;


  return (
    <div className="max-w-7xl mx-auto pt-10 p-4 flex flex-col lg:flex-row gap-8 mt-8 pb-20">
      {/* Checkout Form */}
      <div className="flex-1 bg-white rounded shadow p-8">
        <h2 className="text-3xl font-bold mb-6">Checkout</h2>

        {cart.length === 0 ? (
          <p>Your cart is empty.</p>
        ) : (
          <form onSubmit={handleSubmit} className="space-y-4">
            <input
              name="name"
              placeholder="Full Name"
              value={form.name}
              onChange={handleChange}
              required
              className="w-full border p-3 rounded"
            />

            <div className="flex flex-col sm:flex-row gap-2">
              <span className="border px-3 py-3 rounded bg-gray-100">+964</span>
              <input
                type="tel"
                name="phone"
                placeholder="750 123 4567"
                value={form.phone}
                onChange={handlePhoneChange}
                required
                className="flex-1 border p-3 rounded"
              />
              {form.phone && !isValidIraqiPhone(form.phone) && (
                <p className="text-red-600 text-sm">Please enter a valid number</p>
              )}


            </div>

            {codeSent && !form.phoneVerified && (
              <div className="flex flex-col sm:flex-row gap-2">
                <input
                  type="text"
                  name="verificationCode"
                  placeholder="Enter verification code"
                  value={form.verificationCode}
                  onChange={handleChange}
                  required
                  className="flex-1 border p-3 rounded"
                />
                <button
                  type="button"
                  onClick={verifyCode}
                  className="bg-blue-500 text-white px-4 py-3 rounded hover:bg-blue-600"
                  disabled={verifying}
                >
                  {verifying ? 'Verifying...' : 'Verify'}
                </button>
              </div>
            )}

            {!codeSent && isValidIraqiPhone(form.phone) && (
              <button
                type="button"
                onClick={sendVerificationCode}
                className="bg-gray-800 text-white text-xs md:text-l py-2 px-4 md:py-3 rounded hover:bg-gray-900"
                disabled={sendingCode}
              >
                {sendingCode ? 'Sending...' : 'Send Verification Code'}
              </button>
            )}

            {verificationMessage && (
              <p className={`text-sm ${form.phoneVerified ? 'text-green-600' : 'text-red-600'}`}>
                {verificationMessage}
              </p>
            )}

            <input
              type="email"
              name="email"
              placeholder="Email (optional)"
              value={form.email}
              onChange={handleChange}
              className="w-full border p-3 rounded"
            />

            {user && savedAddresses.length > 0 && (
              <div>
                <label className="block font-medium mb-1">Select Saved Address</label>
                <select
                  className="w-full border p-3 rounded mb-2"
                  value={form.selectedAddressIndex ?? ""}
                  onChange={e => {
                    const idx = e.target.value;
                    const addr = savedAddresses[idx];
                    if (addr) {
                      setForm(f => ({
                        ...f,
                        address: addr.addressLine || "",
                        city: addr.city || "",
                        phone: addr.phone ? addr.phone.replace("+964", "") : "",
                        selectedAddressIndex: idx
                      }));
                    }
                  }}

                >
                  <option value="">Choose an address...</option>
                  {savedAddresses.map((addr, idx) => (
                    <option value={idx} key={idx}>
                      {addr.label} - {addr.addressLine}, {addr.city}
                    </option>
                  ))}
                </select>

              </div>
            )}

            <input
              name="address"
              placeholder="Delivery Address"
              value={form.address}
              onChange={handleChange}
              required
              className="w-full border p-3 rounded"
            />

            <input
              name="city"
              placeholder="City"
              value={form.city}
              onChange={handleChange}
              required
              className="w-full border p-3 rounded"
            />

            <textarea
              name="note"
              placeholder="Additional notes (optional)"
              value={form.note}
              onChange={handleChange}
              className="w-full border p-3 rounded"
            />
            <div className="mb-4">
              <div className="text-sm font-medium mb-2 flex items-center gap-2">
                Select Guarantee:

                {/* Info Tooltip */}
                <div className="relative group cursor-pointer">
                  <div className="w-4 h-4 bg-blue-500 text-white text-[11px] font-bold rounded-full flex items-center justify-center">
                    i
                  </div>
                  <div className="absolute z-10 hidden group-hover:block bg-white text-gray-700 text-xs border border-gray-200 rounded-md shadow p-3 w-[220px] max-w-xs top-6 left-1/2 -translate-x-1/2">
                    Our $5 warranty covers manufacturing defects for 1 year, including loose pearls, locks, and setting issues. It does not cover misuse or lost items.
                  </div>
                </div>
              </div>
              <div className="flex flex-col sm:flex-row gap-2">
                <button
                  type="button"
                  onClick={() => setForm({ ...form, guarantee: true })}
                  className={`px-4 py-2 rounded border text-sm font-medium transition ${form.guarantee
                    ? 'bg-green-600 text-white border-green-700'
                    : 'bg-white text-black border-gray-300 hover:border-black'
                    }`}
                >
                  Paid Guarantee ($5)
                </button>
                <button
                  type="button"
                  onClick={() => setForm({ ...form, guarantee: false })}
                  className={`px-4 py-2 rounded border text-sm font-medium transition ${!form.guarantee
                    ? 'bg-green-600 text-white border-green-700'
                    : 'bg-white text-black border-gray-300 hover:border-black'
                    }`}
                >
                  No Guarantee
                </button>
              </div>
            </div>

            <div>
              <label className="inline-flex items-center gap-2">
                <input
                  type="radio"
                  name="paymentMethod"
                  value="cod"
                  checked
                  readOnly
                  className="accent-green-600"
                />
                Cash on Delivery
              </label>
            </div>

            <button
              type="submit"
              className="mt-4 w-full bg-green-600 text-white py-3 text-center text-base rounded-md shadow hover:bg-green-700 transition"
            >
              Place Order (${total})
            </button>
          </form>
        )}
      </div>

      {/* Order Summary */}
      {cart.length > 0 && (
        <div className="w-full lg:w-1/3 bg-white rounded shadow p-6 mt-8 lg:mt-0 lg:sticky lg:top-8 h-fit">
          <h3 className="text-2xl font-semibold mb-4">Order Summary</h3>
          <ul className="divide-y overflow-auto max-h-[400px]">
            {cart.map((item, idx) => (
              <li key={idx} className="py-4 flex flex-col sm:flex-row gap-4 items-center sm:items-start text-center sm:text-left"
              >
                <img
                  src={item.photos?.[0] ? `/uploads/${item.photos[0].replace(/\\/g, '/')}` : '/fallback.jpg'}
                  alt={item.name}
                  className="w-20 h-20 rounded object-cover mx-auto sm:mx-0"
                />
                <div>
                  <p className="font-medium">{item.name}</p>
                  <p className="text-sm text-gray-500">Size: {item.size}</p>
                  <p className="text-sm text-gray-500">Qty: {item.quantity || 1}</p>


                  <p className="font-semibold">${(item.price * (item.quantity || 1)).toFixed(2)}</p>
                  {form.guarantee && (
                    <div className="flex justify-between text-sm text-green-700">
                      <span>1-Year Guarantee  $5.00</span>
                    </div>
                  )}
                  {discount > 0 && (
                    <div className="flex justify-between text-sm text-green-700">
                      <span>Promo Discount</span>
                      <span>-${discount.toFixed(2)}</span>
                    </div>
                  )}
                </div>

              </li>
            ))}
          </ul>

          <div className="mt-4 pt-4 border-t font-bold flex justify-between text-lg">
            <span>Total:</span>
            <span>${total}</span>
          </div>
        </div>
      )}
    </div>
  );
};

export default CheckoutPage;
